import { useMatches } from "@tanstack/react-router";
import { useMemo } from "react";

import { usePageTitleOverrideValue } from "@/providers/hooks/use-page-title-override";

export const usePageTitle = () => {
    const matches = useMatches();
    const override = usePageTitleOverrideValue();

    const staticTitle = useMemo(() => {
        return matches.reduceRight((foundTitle, match) => {
            if (foundTitle) return foundTitle;

            const config = match.staticData?.config;
            return config?.title ?? config?.breadcrumb?.title ?? config?.sidebar?.label ?? "";
        }, "");
    }, [matches]);

    if (override) {
        return { title: override, translate: false };
    }

    return { title: staticTitle, translate: true };
};
